import classNames from 'classnames';

import Anchor from '~components/Anchor/Anchor';

type Props = {
    className?: string;
    customDisclaimer?: string;
};

const FormDisclaimer = ({ className = '', customDisclaimer }: Props) => {
    const disclaimerText =
        customDisclaimer || 'Your information and use of this site is governed by our most recent ';

    return (
        <p className={classNames('font-poppins text-12 leading-16', className)}>
            {disclaimerText}
            <Anchor
                to="/about-ehealth/terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
                className="text-link"
            >
                Terms of Use
            </Anchor>
            {' and '}
            <Anchor
                to="/about-ehealth/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-link"
            >
                Privacy Policy
            </Anchor>
            .
        </p>
    );
};

export default FormDisclaimer;
